<div class="apc" dir="rtl">

  @if (kind === 'subscription') {
    <!-- Monthly / yearly switch -->
    <div class="apc-toggle" role="radiogroup" aria-label="תקופת חיוב">
      <button type="button" role="radio" class="apc-toggle__btn"
              [class.apc-toggle__btn--on]="period === 'MONTHLY'"
              [attr.aria-checked]="period === 'MONTHLY'"
              (click)="setPeriod('MONTHLY')">חודשי</button>
      <button type="button" role="radio" class="apc-toggle__btn"
              [class.apc-toggle__btn--on]="period === 'YEARLY'"
              [attr.aria-checked]="period === 'YEARLY'"
              (click)="setPeriod('YEARLY')">שנתי</button>
    </div>
  }

  <!-- SCRUM-313: coupon option first (per-ad tab, logged-in users with a usable coupon) -->
  @if (kind === 'ad' && coupons.length) {
    <section class="apc-coupon" aria-labelledby="apc-coupon-title">
      <h4 id="apc-coupon-title" class="apc-coupon__title">פרסום באמצעות קופון</h4>
      <div class="apc-coupon__list" role="radiogroup" aria-labelledby="apc-coupon-title">
        @for (c of coupons; track c.redemption_id) {
          <label class="apc-coupon__item" [class.apc-coupon__item--on]="selectedCouponId === c.redemption_id">
            <input type="radio" class="apc-coupon__radio" name="apc-coupon-pick"
                   [checked]="selectedCouponId === c.redemption_id"
                   (change)="selectCoupon(c)">
            <span class="apc-coupon__mark" aria-hidden="true"></span>
            <span class="apc-coupon__content">
              <span class="apc-coupon__top">
                <span class="apc-coupon__name">{{ c.title }}</span>
                @if (c.recommended) {
                  <span class="apc-coupon__rec">מומלץ</span>
                }
              </span>
              <span class="apc-coupon__meta">
                <span class="apc-coupon__level">{{ c.ad_level_label }}</span>
                <span>{{ c.remaining_text }}</span>
                <span>{{ c.duration_text }}</span>
                <span class="apc-coupon__muted">{{ c.expires_text }}</span>
              </span>
            </span>
          </label>
        }
      </div>
      <button type="button" class="apc-card__cta apc-coupon__cta" [disabled]="!selectedCoupon" (click)="pickCoupon()">
        המשך לפרסום עם הקופון
      </button>
    </section>
  }

  @if (state === 'loading') {
    <div class="apc-state" role="status" aria-live="polite">
      <span class="apc-spinner" aria-hidden="true"></span>
      <span>טוען את מסלולי הפרסום...</span>
    </div>
  }

  @if (state === 'error') {
    <div class="apc-state apc-state--error" role="alert">
      <span>לא הצלחנו לטעון את מסלולי הפרסום. בדוק את החיבור ונסה שוב.</span>
      <button type="button" class="apc-retry" (click)="retry()">נסה שוב</button>
    </div>
  }

  @if (state === 'ready' && !cards.length) {
    <div class="apc-state" role="status">{{ emptyText }}</div>
  }

  @if (state === 'ready' && cards.length) {
    <div class="apc-grid">
      @for (card of cards; track trackByKey($index, card)) {
        <article class="apc-card" [class.apc-card--disabled]="card.disabled" [attr.aria-label]="'מסלול ' + card.name">
          <h4 class="apc-card__name">{{ card.name }}</h4>

          <div class="apc-card__price-block">
            <div class="apc-card__price">
              <span class="apc-card__amount" [class.apc-card__amount--free]="card.free" dir="ltr">{{ card.price }}</span>
              @if (card.periodLabel) {
                <span class="apc-card__period">{{ card.periodLabel }}</span>
              }
            </div>
            @if (card.equivalent) {
              <div class="apc-card__equiv">{{ card.equivalent }}</div>
            }
            @if (card.saving) {
              <div class="apc-card__saving">{{ card.saving }}</div>
            }
          </div>

          <div class="apc-card__allowance">{{ card.chip }}</div>

          <ul class="apc-card__benefits">
            @for (b of card.benefits; track $index) {
              <li>{{ b }}</li>
            }
            @if (card.note) {
              <li class="apc-card__note">{{ card.note }}</li>
            }
          </ul>

          <button type="button" class="apc-card__cta" [disabled]="card.disabled" (click)="pick(card)">
            {{ card.cta }}
          </button>
        </article>
      }
    </div>
  }
</div>
